<template>
    <div class="dashboard">
        <div class="content">
            <el-row class="mb10">
                <el-col :span="1" class="text-center bold">
                    Дата:
                </el-col>
                <el-col :span="4">
                    <el-date-picker
                        v-model="daysRange"
                        type="daterange"
                        range-separator="по"
                        start-placeholder="дата"
                        end-placeholder="дата"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                        @change="getRating"
                    />
                </el-col>
                <el-col :span="4">
                    <el-button type="warning" @click="showManagers" class="managers-button">
                        {{ showManagersButtonText }}
                    </el-button>
                </el-col>
                <el-col :span="3" class="text-center bold">
                    Показывать уволенных
                </el-col>
                <el-checkbox v-model="showFired" @change="getRating" />
            </el-row>
            <el-row v-loading="loading">
                <el-col>
                    <div class="table offices">
                        <div class="table-header">
                            <div class="table-row">
                                <div class="table-cell bold">
                                    <el-tooltip popper-class="table-header-hint" content="Рейтинг" effect="light" placement="top">
                                        <span>Рейтинг</span>
                                    </el-tooltip>
                                </div>
                                <div class="table-cell bold">
                                    <el-tooltip popper-class="table-header-hint" content="Офис" effect="light" placement="top">
                                        <span>Офис</span>
                                    </el-tooltip>
                                </div>
                                <div
                                    v-for="column in columns"
                                    :key="column.field + 'header'"
                                    :class="[
                                        'table-cell bold',
                                        {'hide': column.field === 'manager' && !isManagersVisible}
                                    ]"
                                    :style="{'width': `${column.width}px`}"
                                >
                                    <el-tooltip popper-class="table-header-hint" :content="column.hint" effect="light" placement="top">
                                        <span>{{ column.title }}</span>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                        <template v-for="(office, indexOffice) in officesData">
                            <div class="table-body" :key="'office' + indexOffice">
                                <div class="table-row office-total">
                                    <div class="table-cell">
                                        {{ indexOffice + 1 }}
                                    </div>
                                    <div class="table-cell text-left" style="width: 100px">
                                        {{ getOfficeName(office.officeId) }}
                                    </div>
                                    <div
                                        v-for="column in columns"
                                        :key="column.field + 'total' + indexOffice"
                                        :class="[
                                            'table-cell',
                                            {'hide-border': column.field === 'manager'},
                                            {'hide': column.field === 'manager' && !isManagersVisible},
                                            {'substrate': column.field === 'sales' || column.field === 'implementation'},
                                            {'empty': Number(office.managersTotal[column.field][0]) === 0 }
                                        ]"
                                        :style="getTotalCellOuterStyle(office.managersTotal, column.field)"
                                    >
                                        <div
                                            :style="getTotalCellInnerStyle(office.managersTotal, column.field)"
                                        >
                                            {{ office.managersTotal[column.field] }}
                                        </div>
                                    </div>
                                </div>
                                <template v-if="isManagersVisible">
                                    <div
                                        v-for="(manager, indexManager) in office.managers"
                                        :key="'manager' + indexManager + indexOffice"
                                        :class="['table-row', 'office', getRowClass(indexManager, office.managers.length), isFiredEmployerClass(manager.date_fired)]"
                                    >
                                        <div class="table-cell empty-cell">
                                        </div>
                                        <div class="table-cell empty-cell">
                                        </div>
                                        <div
                                            v-for="column in columns"
                                            :key="column.field + 'data'"
                                            :class="[column.cellClass, getShadowClass(manager, column.field)]"
                                            :style="getCellOuterStyle(manager, column.field, indexManager + 1, office.managers.length)"
                                        >
                                            <div
                                                :style="getCellInnerStyle(manager, column.field, indexManager + 1, office.managers.length)"
                                            >
                                                <div v-if="column.field === 'manager'" class="rating">
                                                    {{ indexManager + 1 }}
                                                </div>
                                                {{ manager[column.field] }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <div class="table-row-empty"></div>
                        <div class="table-footer">
                            <div class="table-row">
                                <div class="table-cell hide-border">
                                </div>
                                <div class="table-cell">
                                    ИТОГО:
                                </div>
                                <div
                                    v-for="column in columns"
                                    :key="column.field + 'total'"
                                    :class="[
                                        'table-cell',
                                        {'hide': column.field === 'manager' && !isManagersVisible},
                                        {'implementation': column.field === 'implementation'}
                                    ]"
                                    :style="getTotalCellOuterStyle(totalData, column.field)"
                                >
                                    <div
                                        :style="getTotalCellInnerStyle(totalData, column.field)"
                                    >
                                        {{ totalData[column.field] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import employersRating from '@/mixins/employersRating';

export default {
    name: 'OfficesRating',
    mixins: [
        employersRating
    ],
    data() {
        return {
            showFired: 0,
            isManagersVisible: false,
            columns: [
                {
                    field: 'manager',
                    title: 'Менеджер',
                    hint: 'Менеджер',
                    cellClass: 'table-cell text-left',
                    width: 200
                },
                {
                    field: 'sales',
                    title: 'Сумма продаж',
                    hint: 'Бюджет договора, заключенного в период минус договора в статусе "Договор фиксация"',
                    cellClass: ['table-cell', 'substrate'],
                    width: 120
                },
                {
                    field: 'plan',
                    title: 'План',
                    hint: 'План',
                    cellClass: 'table-cell',
                    width: 80
                },
                {
                    field: 'implementation',
                    title: 'Выполнение %',
                    hint: 'Сумма продаж/план',
                    cellClass: 'table-cell substrate',
                    width: 80
                },
                {
                    field: 'dealsVsLeads',
                    title: 'Кол-во сделок / не целевых',
                    hint: 'кол-во созданных сделок в период фильтра/кол-во лидов "не целевой" с датой создания лида в период',
                    cellClass: 'table-cell',
                    width: 80
                },
                {
                    field: 'measurementVsRefuseBeforeMeteringVsTechRefuse',
                    title: 'Кол-во замеров / ОДЗ / Техотказ',
                    hint: 'кол-во сделок с датой замера в период И без галки ОДЗ И Техотказ ' +
                        '/ кол-во сделок с датой замера в период И с галкой ОДЗ / кол-во сделок с датой замера в период И с галкой Техотказ',
                    cellClass: 'table-cell',
                    width: 80
                },
                {
                    field: 'dealsWithContractDateCount',
                    title: 'Кол-во договоров',
                    hint: 'кол-во сделок с датой договора в период',
                    cellClass: 'table-cell',
                    width: 80
                },
                {
                    field: 'dealsWithClosedStatusCount',
                    title: 'Кол-во отказов',
                    hint: 'кол-во сделок с датой установки статуса "Закрыто и нереализовано"',
                    cellClass: 'table-cell',
                    width: 80
                },
                {
                    field: 'square',
                    title: 'м2',
                    hint: 'сделки с датой договора в период - сумма "Квадратура"',
                    cellClass: 'table-cell',
                    width: 80
                },
                {
                    field: 'squarePrice',
                    title: 'Цена м2',
                    hint: 'Сумма продаж/м2',
                    cellClass: 'table-cell',
                    width: 80
                },
                {
                    field: 'discountPercent',
                    title: 'Скидка %',
                    hint: 'сумма всех скидок(скидки в процентах) В РУБЛЯХ по сделкам с датой договора в период / сумма продаж',
                    cellClass: 'table-cell',
                    width: 80
                },
                {
                    field: 'contactByMeasurement',
                    title: 'Обращение/замер %',
                    hint: 'кол-во замеров без ОДЗ И Техотказ/кол-во сделок',
                    cellClass: 'table-cell',
                    width: 80
                },
                {
                    field: 'measurementByContract',
                    title: 'Замер/Договор %',
                    hint: 'кол-во замеров без ОДЗ и Техотказ / кол-во договоров',
                    cellClass: 'table-cell',
                    width: 80
                },
                {
                    field: 'contactByContract',
                    title: 'Конверсия (Обр./Договор) %',
                    hint: 'кол-во договоров/кол-во сделок',
                    cellClass: 'table-cell',
                    width: 80
                }
            ]
        };
    },
    computed: {
        officesData() {
            return this.$store.state.analytics.offices;
        },
        totalData() {
            return this.$store.state.analytics.officesTotal;
        },
        showManagersButtonText() {
            return (this.isManagersVisible ? 'Скрыть' : 'Показать') + ' сотрудников';
        }
    },
    methods: {
        showManagers() {
            this.isManagersVisible = !this.isManagersVisible;
        },
        async getRating() {
            try {
                this.loading = true;
                await this.$store.dispatch('analytics/getOfficesRating', {
                    startDay: this.daysRange[0],
                    endDay: this.daysRange[1],
                    showFired: +this.showFired
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        getOfficeName(id) {
            const office = this.$store.state.references.offices.filter(office => office.id === id);
            return office.length ? office[0].name : '';
        }
    }
};
</script>
